export default __webpack_public_path__ + "static/media/ruby-red-grapefruit@2x.49f27954.png";